import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchFormData } from '../fetch';
import { QueryKeys } from '../keys';

export const useCreateQuotationAttachment = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => {
      const body = new FormData();
      body.append('file', file, file.name);

      return fetchFormData(`/quotations/${id}/attachment`, {
        method: 'POST',
        body,
      });
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.show.attachment(id) });
    },
  });
};
